import request from '@/utils/request'

let DataApi = {
  /*用户接口*/
  getUser(data, errorback) {
    return request._post('/shop/data.user/lists', data, errorback);
  },
  /*用户接口*/
  getAgentBoss(data, errorback) {
    return request._post('/shop/data.user/agent', data, errorback);
  },
  /*门店接口*/
  getStoreList(data, errorback) {
    return request._post('/shop/data.store/index', data, errorback);
  },
  /*地区接口*/
  getArea(data, errorback) {
    return request._post('/shop/data.region/getArea', data, errorback);
  },
  /*门店接口*/
  getStore(data, errorback) {
    return request._post('/shop/store.store/index', data, errorback);
  },
  /*服务接口*/
  getService(data, errorback) {
    return request._post('/shop/service.service/index', data, errorback);
  },
  /*平台接口*/
  getPlantform(data, errorback) {
    return request._get('/shop/data.plantform/getList', data, errorback);
  },
  /*标签接口*/
  getLabel(data, errorback) {
    return request._get('/shop/data.label/getList', data, errorback);
  },
  /*职业接口*/
  getJob(data, errorback) {
    return request._get('/shop/data.job/getList', data, errorback);
  },
  /*爱好接口*/
  getHobby(data, errorback) {
    return request._get('/shop/data.hobby/getList', data, errorback);
  },
  /*待处理数据*/
  getWaitSettled(data, errorback) {
    return request._get('/shop/data.waitSettled/index', data, errorback);
  },

}
export default DataApi;



// WEBPACK FOOTER //
// ./src/api/data.js